import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M15 11V9.416', key: 'v2ax0h' }],
  ['path', { d: 'M17 9a5 5 0 00-3 1', key: '1d2djj' }],
  ['path', { d: 'M7 9a5 5 0 013 1', key: 'y5n5ez' }],
  ['path', { d: 'M9 11V9.416', key: '1t25y0' }],
  ['path', { d: 'M9 16a5 5 0 016.001 0', key: '111vmx' }],
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
];

/**
 * @component @name FaceAngry
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgMTFWOS40MTYiIC8+CiAgPHBhdGggZD0iTTE3IDlhNSA1IDAgMDAtMyAxIiAvPgogIDxwYXRoIGQ9Ik03IDlhNSA1IDAgMDEzIDEiIC8+CiAgPHBhdGggZD0iTTkgMTFWOS40MTYiIC8+CiAgPHBhdGggZD0iTTkgMTZhNSA1IDAgMDE2LjAwMSAwIiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjEwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/face-angry
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FaceAngry = createLucideIcon('face-angry', __iconNode);

export default FaceAngry;
